export default __webpack_public_path__ + "static/media/zoom-in-disabled.cb308f8c.svg";